import type { schemaType as StrapiEscapadasSchemaType } from '~~/modules/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/modules/api/strapi/cottages-page/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-media-banner/s-media-banner-wrapper.vue'

export const useToSMediaBannerWrapper = () => {
  const fromStrapiEscapadasDetail = (
    data: StrapiEscapadasSchemaType,
  ): propsInterface | null => {
    let items: propsInterface['items'] = []

    if (data.attributes.media_banner) {
      items = data.attributes.media_banner.map(item => {
        return {
          title: item.title,
          subtitle: item.subtitle,
          text: item.text,
          image: item.image.data?.attributes.url,
          button: item.button,
          youtubeUrl: item.youtube_url,
        }
      })
    }

    return { items }
  }

  const fromStrapiCottagesPage = (
    data: StrapiCottagesPagechemaType,
  ): propsInterface | null => {
    let items: propsInterface['items'] = []

    if (data.attributes.media_banner) {
      items = data.attributes.media_banner.map(item => {
        return {
          title: item.title,
          subtitle: item.subtitle,
          text: item.text,
          image: item.image.data?.attributes.url,
          button: item.button,
          youtubeUrl: item.youtube_url,
        }
      })
    }

    return { items }
  }

  return { fromStrapiEscapadasDetail, fromStrapiCottagesPage }
}
